var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4965 3.33959L12.5055 2.32288C12.0859 1.89237 11.4074 1.89237 10.9923 2.32288L2.3147 11.2214C1.8951 11.6519 1.8951 12.3481 2.3147 12.774L10.9923 21.6771C11.4119 22.1076 12.0904 22.1076 12.5055 21.6771L13.4965 20.6604C13.9205 20.2253 13.9116 19.5155 13.4786 19.0895L8.09976 13.8319H20.9287C21.5224 13.8319 22 13.3419 22 12.7328V11.2672C22 10.6581 21.5224 10.1681 20.9287 10.1681H8.09976L13.4786 4.91047C13.9161 4.48454 13.925 3.77467 13.4965 3.33959Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.54ece1f0d1f5c2081f55329da350dc80.svg";
export { ForwardRef as ReactComponent };